'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter, useSearchParams } from 'next/navigation';
import { useTransition } from 'react';
import { useFollowCourse } from '@openclassrooms/data-connect-web/learning-activity';
import { useUnfollowCourse } from '@openclassrooms/data-connect-web/learning-activity';
import { ROUTES, getPathName } from '@openclassrooms/routing';
import { useCourseContext } from '../_contexts/CourseContext';
import getNextPartFromToc from '../_utils/getNextPartFromToc';
import tocItemToUrl from '../_utils/tocItemToUrl';
type UseHeroActionsParams = {
  userId?: number;
};
export default function useHeroActions(t0) {
  const $ = _c(34);
  const {
    userId
  } = t0;
  const router = useRouter();
  const searchParams = useSearchParams();
  const [followCourse, t1] = useFollowCourse();
  const {
    isPending: isFollowPending
  } = t1;
  const [unfollowCourse, t2] = useUnfollowCourse();
  const {
    isPending: isUnfollowPending
  } = t2;
  const [isTransitioning, startTransition] = useTransition();
  const {
    course,
    flatToc
  } = useCourseContext();
  let t3;
  if ($[0] !== flatToc) {
    t3 = getNextPartFromToc(flatToc);
    $[0] = flatToc;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const nextChapter = t3;
  let t4;
  if ($[2] !== course || $[3] !== followCourse || $[4] !== nextChapter?.id || $[5] !== nextChapter?.slug || $[6] !== router || $[7] !== userId) {
    t4 = () => {
      if (!course?.id || userId === undefined) {
        return;
      }
      const courseId = Number(course.id);
      const courseSlug = course.slug;
      followCourse({
        userId: Number(userId),
        courseId
      }, {
        onSuccess: () => {
          const redirectPath = getPathName(ROUTES.COURSES.CHAPTERS, {
            courseIdSlug: `${courseId}-${courseSlug}`,
            chapterIdSlug: `${nextChapter?.id}-${nextChapter?.slug}`
          }, false);
          startTransition(() => {
            router.push(redirectPath);
          });
        }
      });
    };
    $[2] = course;
    $[3] = followCourse;
    $[4] = nextChapter?.id;
    $[5] = nextChapter?.slug;
    $[6] = router;
    $[7] = userId;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleFollowCourse = t4;
  let t5;
  if ($[9] !== course || $[10] !== router || $[11] !== unfollowCourse || $[12] !== userId) {
    t5 = () => {
      if (!course?.id || userId === undefined) {
        return;
      }
      unfollowCourse({
        userId,
        courseId: course.id
      }, {
        onSuccess: () => {
          startTransition(() => {
            router.refresh();
          });
        }
      });
    };
    $[9] = course;
    $[10] = router;
    $[11] = unfollowCourse;
    $[12] = userId;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const handleUnfollowCourse = t5;
  let t6;
  if ($[14] !== course || $[15] !== nextChapter?.id || $[16] !== nextChapter?.slug || $[17] !== nextChapter?.title || $[18] !== nextChapter?.type || $[19] !== router || $[20] !== searchParams) {
    t6 = () => {
      if (!course) {
        return;
      }
      const nextChapterPath = tocItemToUrl(course, {
        id: nextChapter?.id,
        type: nextChapter?.type,
        title: nextChapter?.title,
        slug: nextChapter?.slug
      }, searchParams?.toString());
      startTransition(() => {
        router.push(nextChapterPath);
      });
    };
    $[14] = course;
    $[15] = nextChapter?.id;
    $[16] = nextChapter?.slug;
    $[17] = nextChapter?.title;
    $[18] = nextChapter?.type;
    $[19] = router;
    $[20] = searchParams;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  const handleContinueCourse = t6;
  let t7;
  if ($[22] !== course?.OpenClassroomsUrl) {
    t7 = new URLSearchParams({
      _target_path: course?.OpenClassroomsUrl || "",
      context: "courseAccess"
    }).toString();
    $[22] = course?.OpenClassroomsUrl;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  const targetPathQueryParam = t7;
  let t8;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = getPathName(ROUTES.AUTH.LOGIN);
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  const loginUrl = `${t8}?${targetPathQueryParam}`;
  const t9 = course?.categoryColor;
  const t10 = isFollowPending || isTransitioning;
  const t11 = isUnfollowPending || isTransitioning;
  let t12;
  if ($[25] !== handleContinueCourse || $[26] !== handleFollowCourse || $[27] !== handleUnfollowCourse || $[28] !== isTransitioning || $[29] !== loginUrl || $[30] !== t10 || $[31] !== t11 || $[32] !== t9) {
    t12 = {
      handleFollowCourse,
      handleUnfollowCourse,
      handleContinueCourse,
      loginUrl,
      categoryColor: t9,
      isFollowLoading: t10,
      isUnfollowLoading: t11,
      isContinueLoading: isTransitioning
    };
    $[25] = handleContinueCourse;
    $[26] = handleFollowCourse;
    $[27] = handleUnfollowCourse;
    $[28] = isTransitioning;
    $[29] = loginUrl;
    $[30] = t10;
    $[31] = t11;
    $[32] = t9;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
}